import React, { FunctionComponent } from "react";
import { Badge, Skeleton, Box } from "@chakra-ui/react";
import { useIntl } from "react-intl";


interface IProps {
  state?: number;
}

export const BESS_STATUS = {
  NONE: 0,
  MANUAL: 1,
  READY: 2,
  REDUCED: 3,
  ERROR: 4,
  SERVICE: 5,
}


const BessStatus: FunctionComponent<IProps> = ({ state }) => {
  const intl = useIntl();

  switch (state) {
    case BESS_STATUS.NONE:
      return (
        <Badge variant={"outline"} colorScheme={"gray"} title={intl.formatMessage({
            id: "command__bess__status__none",
            defaultMessage: "No state",
          })}>
          <Box display="inline-block" w="2" h="3" />
        </Badge>
      )
    case BESS_STATUS.MANUAL:
      return (
        <Badge variant="solid" colorScheme={"orange"}>
          {intl.formatMessage({
            id: "command__bess__status__manual",
            defaultMessage: "MANUAL",
          })}
        </Badge>
      )
    case BESS_STATUS.READY:
      return (
        <Badge variant="solid" colorScheme={"green"}>
          {intl.formatMessage({
            id: "command__bess__status__ready",
            defaultMessage: "READY",
          })}
        </Badge>
      )
    case BESS_STATUS.REDUCED:
      return (
        <Badge variant="solid" colorScheme={"orange"}>
          {intl.formatMessage({
            id: "command__bess__status__reduced",
            defaultMessage: "REDUCED",
          })}
        </Badge>
      )
    case BESS_STATUS.ERROR:
      return (
        <Badge variant="solid" colorScheme={"red"}>
          {intl.formatMessage({
            id: "command__bess__status__error",
            defaultMessage: "ERROR",
          })}
        </Badge>
      )
    case BESS_STATUS.SERVICE:
      return (
        <Badge variant="solid" colorScheme={"gray"}>
          {intl.formatMessage({
            id: "command__bess__status__service",
            defaultMessage: "SERVICE",
          })}
        </Badge>
      )
    default:
      return (
        <Skeleton minW={5} w={10} h={3} />
      )
  }
};

export default BessStatus;
